import type ReminderOptionType from '../helpers/ReminderOptionType';
import getNonAllDayReminderString from './getNonAllDayReminderString';
import getAllDayReminderString from './getAllDayReminderString';

export default function addReminderToOptions(
    isAllDay: boolean,
    selectedReminderTimeInMinutes: number,
    reminderDropdownOptions: ReminderOptionType[]
): ReminderOptionType[] {
    let optionToAdd;
    if (isAllDay) {
        optionToAdd = {
            key: selectedReminderTimeInMinutes,
            text: getAllDayReminderString(selectedReminderTimeInMinutes),
        };
    } else {
        optionToAdd = {
            key: selectedReminderTimeInMinutes,
            text: getNonAllDayReminderString(selectedReminderTimeInMinutes),
        };
    }

    reminderDropdownOptions.push(optionToAdd);
    reminderDropdownOptions.sort((a, b) => a.key - b.key);

    return reminderDropdownOptions;
}
